import React from "react";
import styles from "./../termsConditions/TermsConditions.module.scss";

const CommunityGuideline = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropogation();
  };
  return (
    <div className={styles.mainDiv}>
      <div className={styles.contentDiv}>
        <h3>Community guidelines</h3>
        <p>
          At Qreativs, we’re building a vibrant, inspiring space for creators
          from all backgrounds. To maintain a safe, respectful, and creative
          environment, we ask all members of our community to follow these
          guidelines.
        </p>
        <ol>
          <li>
            <span>What We Encourage</span>
            <ul style={{ listStyleType: "disc" }}>
              <li>
                <span>Respect & Kindness</span>
                <p>
                  Treat everyone with respect. Constructive feedback is welcome,
                  but personal attacks, insults, or harassment will not be
                  tolerated.
                </p>
              </li>
              <li>
                <span>Originality & Creativity</span>
                <p>
                  Share your original work or properly credit collaborations.
                  Inspire others with your unique ideas.
                </p>
              </li>
              <li>
                <span>Positive Collaboration</span>
                <p>
                  Work together respectfully. Honor project agreements and be
                  communicative and professional in your collaborations.
                </p>
              </li>
              <li>
                <span>Inclusive Participation</span>
                <p>
                  We welcome creators of all backgrounds, identities, and
                  experiences. Discrimination of any kind is strictly
                  prohibited.
                </p>
              </li>
              <li>
                <span>Safe Sharing</span>
                <p>
                  Share content appropriate for a general creative community. If
                  your work includes sensitive or mature themes, please use the
                  appropriate content warnings.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <span>What’s Not Allowed</span>
            <ul style={{ listStyleType: "disc" }}>
              <li>
                <span>Hate Speech or Harassment</span>
                <p>
                  Any content that attacks individuals or groups based on race,
                  ethnicity, religion, gender, orientation, disability, or other
                  protected characteristics.
                </p>
              </li>
              <li>
                <span>Spam or Self-Promotion Abuse</span>{" "}
                <p>
                  Spammy posts, repetitive self-promotion without engagement,
                  and irrelevant links detract from the community experience.
                </p>
              </li>
              <li>
                <span>Plagiarism & Intellectual Property Violations</span>{" "}
                <p>
                  Do not share work that you don’t own or have permission to
                  share.
                </p>
              </li>
              <li>
                <span>Inappropriate or Harmful Content</span>
                <p>
                  No sexually explicit, violent, threatening, or otherwise
                  harmful content. This includes threats of harm to yourself or
                  others.
                </p>
              </li>
              <li>
                <span>Dishonest Behavior</span>
                <p>
                  Misrepresentation of your identity, credentials, or work, as
                  well as scamming or fraud, is strictly prohibited.
                </p>
              </li>
            </ul>
          </li>
          <li>
            <span>Reporting Issues</span>
            <p>
              If you encounter content or behavior that violates these
              guidelines, please report it using our reporting tools. Our
              moderation team reviews all reports carefully and takes action as
              needed.
            </p>
          </li>
          <li>
            <span>Enforcement</span>
            <p>Violations of these guidelines may result in:</p>
            <ul style={{ listStyleType: "disc" }}>
              <li>A warning</li>
              <li>Removal of content.</li>
              <li>Temporary account suspension.</li>
              <li>Permanent account removal.</li>
            </ul>
            <p>We strive to apply these actions fairly and transparently.</p>
          </li>
          <li>
            <span>Help Us Grow a Safe Creative Space</span>
            <p>
              These guidelines are a shared responsibility. Together, we can
              make Qreativs a supportive and inspiring space where creativity
              thrives. If you have any questions or feedback, reach out to us at
              support email address.
            </p>
          </li>
        </ol>
      </div>
    </div>
  );
};

export default CommunityGuideline;
